import React from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../hooks"
import { fetchProfile } from "../network"
import { setErrorAlertMessage } from "../stores/NetworkStore"
import Login from "./component/auth/login"
import { Modal } from "./component/modal/modal"
import "./auth.css"

export default function Auth() {
  const { t } = useTranslation()
  const isSupposedlyMobile =
    navigator.maxTouchPoints > 0 &&
    window.matchMedia("(orientation: portrait)").matches
  const [twitchCallbackMessage, setTwitchCallbackMessage] = React.useState<{
    kind: "success" | "error"
    body: string
  } | null>(null)
  const [shouldRefreshProfile, setShouldRefreshProfile] = React.useState(false)
  const dispatch = useAppDispatch()
  const networkError = useAppSelector((state) => state.network.error)
  const uid = useAppSelector((state) => state.network.uid)

  React.useEffect(() => {
    const url = new URL(window.location.href)
    const twitchVerify = url.searchParams.get("twitchVerify")
    if (!twitchVerify) {
      return
    }

    if (twitchVerify === "success") {
      setTwitchCallbackMessage({
        kind: "success",
        body: "Your Twitch account has been linked successfully."
      })
      setShouldRefreshProfile(true)
    } else {
      setTwitchCallbackMessage({
        kind: "error",
        body: twitchVerify.replace(/\+/g, " ")
      })
    }

    url.searchParams.delete("twitchVerify")
    window.history.replaceState({}, "", url.toString())
  }, [])

  React.useEffect(() => {
    if (!shouldRefreshProfile || !uid) {
      return
    }

    fetchProfile(true)
      .catch((error) => {
        dispatch(
          setErrorAlertMessage(
            error instanceof Error ? error.message : "Unable to refresh profile"
          )
        )
      })
      .finally(() => {
        setShouldRefreshProfile(false)
      })
  }, [dispatch, shouldRefreshProfile, uid])

  return (
    <div className="auth-page">
      <div className="auth-bg" aria-hidden="true">
        <div className="auth-bg-glow auth-bg-glow--left" />
        <div className="auth-bg-glow auth-bg-glow--right" />
        <div className="auth-bg-grid" />
      </div>

      {isSupposedlyMobile && (
        <p className="auth-mobile-warning">{t("auth.mobile_warning")}</p>
      )}

      <div className="auth-shell">
        <section className="auth-brand">
          <p className="auth-brand-kicker">LAOSI AUTO CHESS</p>
          <h1 className="auth-brand-title">
            老四<span>自走棋</span>
          </h1>
        </section>

        <section className="auth-card">
          <Login />
        </section>
      </div>

      <Modal
        show={networkError != null}
        onClose={() => {
          dispatch(setErrorAlertMessage(null))
        }}
        className="is-dark basic-modal-body"
        body={<p style={{ padding: "1em" }}>{networkError}</p>}
      />
      <Modal
        show={twitchCallbackMessage != null}
        onClose={() => {
          setTwitchCallbackMessage(null)
        }}
        className="is-dark basic-modal-body"
        header={
          twitchCallbackMessage?.kind === "success"
            ? "Twitch Linked"
            : "Twitch Verification Error"
        }
        body={<p style={{ padding: "1em" }}>{twitchCallbackMessage?.body}</p>}
      />
    </div>
  )
}
